import React, { Fragment, useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SearchAgentCallAnswerDialog from "./SearchAgentCallAnswerDialog";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface IAgentQaiChallengeNotesHeaderProps {
    questionViewModel: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
    challengeCount: number | null
}

export default function AgentQaiChallengeNotesHeader({ questionViewModel, filters, challengeCount }: IAgentQaiChallengeNotesHeaderProps) {
    const [dialogOpen, setDialogOpen] = useState(false)

    const handleDialogOpen = () => {
        setDialogOpen(true);
    }

    return (
        <Fragment>
            <Grid
                container
                size={12}
                justifyContent="space-between"
                height="5%">
                <Grid>
                    <Typography variant="h5">Agent Challenges</Typography>
                </Grid>
                <Grid>
                    <Typography variant="h5">Challenge Count: {challengeCount ?? questionViewModel.challengeCount}</Typography>
                </Grid>
                <Grid size={4}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={handleDialogOpen}>
                        Find example calls
                    </Button>
                </Grid>
            </Grid>
            <SearchAgentCallAnswerDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                questionViewModel={questionViewModel}
                filters={filters}
            />
        </Fragment >
    )
}